var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DynamicMasterLayout',[_c('WebsiteDetailPage',{attrs:{"details":_vm.details}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }